module.exports.getRange = day => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - day);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return [start, end];
};
